/**
 * PROTOTYPE route — throwaway.
 * Question: does web capture feel fast enough — movable Composer, overlay, hover+T, ambient Event?
 * Three variants via ?variant=A|B|C (bottom switcher).
 *
 * Open: /prototype/contextual-tasks
 */
import type { MetaFunction } from '@remix-run/node'
import {
	PrototypeSwitcher,
	usePrototypeVariant,
} from '#app/components/prototype/contextual-tasks/PrototypeSwitcher'
import {
	VariantA,
	VariantB,
	VariantC,
} from '#app/components/prototype/contextual-tasks/ContextualTasksUI'
import { usePrototypeState } from '#app/components/prototype/contextual-tasks/usePrototypeState'

export const meta: MetaFunction = () => [
	{ title: 'PROTOTYPE — Contextual tasks' },
]

export default function PrototypeContextualTasks() {
	const state = usePrototypeState()
	const variant = usePrototypeVariant()

	return (
		<>
			{variant === 'A' ? <VariantA state={state} /> : null}
			{variant === 'B' ? <VariantB state={state} /> : null}
			{variant === 'C' ? <VariantC state={state} /> : null}
			<PrototypeSwitcher />
		</>
	)
}
